import React, { useState } from 'react';
import { Layout, Button, Space } from 'antd';
import { 
  LogoutOutlined, 
  SyncOutlined,
  MessageOutlined,
  UserOutlined
} from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import ConnectionStatusComponent, { ConnectionStatus } from './ConnectionStatus';
import UserManagementModal from '../UserManagementModal';
import LanguageSwitcher from '../LanguageSwitcher';
import { useWebSocket } from '../../contexts/WebSocketProvider';

import '../styles/AppHeader.css';

const { Header } = Layout;

interface AppHeaderProps {
  onLogout: () => void;
  connectionStatus?: ConnectionStatus;
  onReconnect?: () => void;
}

const AppHeader: React.FC<AppHeaderProps> = ({ 
  onLogout, 
  connectionStatus = 'disconnected',
  onReconnect = () => {}
}) => {
  const { isAdmin } = useWebSocket();
  const { t } = useTranslation();
  const [userManagementModalVisible, setUserManagementModalVisible] = useState(false);

  return (
    <Header className="app-header">
      <div className="logo">
        <MessageOutlined className="logo-icon" />
      </div>
      
      <div className="header-right">
        <Space>
          <ConnectionStatusComponent status={connectionStatus} onReconnect={onReconnect} />
          
          <LanguageSwitcher />
          
          {isAdmin && (
            <Button 
              type="text" 
              icon={<UserOutlined />} 
              onClick={() => setUserManagementModalVisible(true)}
              title={t('header.userManagement')}
            />
          )}
          
          <Button 
            type="text" 
            icon={<LogoutOutlined />} 
            onClick={onLogout}
            title={t('header.logout')}
          />
        </Space>
      </div>

      {/* Модальное окно управления пользователями */}
      <UserManagementModal 
        visible={userManagementModalVisible}
        onClose={() => setUserManagementModalVisible(false)}
      />
    </Header>
  );
};

export default AppHeader; 